import { useMutation } from 'react-query';
import { register } from 'src/models/user';
import { updateStudent } from 'src/services/students';

export default function UpdateStudent() {
  return useMutation(({ id, data }: { id: number; data: register }) =>
    updateStudent(data, id)
  );
}
